import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Menu from "../pages/menu/page";
import Gallery from "../pages/gallery/page";
import Location from "../pages/location/page";

// Admin Imports
import LoginPage from "../pages/admin/LoginPage";
import AdminLayout from "../components/layout/AdminLayout";
import DashboardPage from "../pages/admin/DashboardPage";
import MenuManagementPage from "../pages/admin/MenuManagementPage";
import CategoryManagementPage from "../pages/admin/CategoryManagementPage";
import GalleryManagementPage from "../pages/admin/GalleryManagementPage";
import GalleryCategoryPage from "../pages/admin/GalleryCategoryPage";
import BusinessInfoPage from "../pages/admin/BusinessInfoPage";
import UserManagementPage from "../pages/admin/UserManagementPage";
import ActivityLogPage from "../pages/admin/ActivityLogPage";
import LandingImagesPage from "../pages/admin/LandingImagesPage";
import ProtectedRoute from "../components/auth/ProtectedRoute";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/menu",
    element: <Menu />,
  },
  {
    path: "/gallery",
    element: <Gallery />,
  },
  {
    path: "/location",
    element: <Location />,
  },
  {
    path: "/admin/login",
    element: <LoginPage />,
  },
  {
    path: "/admin",
    element: (
      <ProtectedRoute>
        <AdminLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: "activity",
        element: <ActivityLogPage />,
      },
      {
        path: "users",
        element: <UserManagementPage />,
      },
      {
        path: "categories",
        element: <CategoryManagementPage />,
      },
      {
        path: "menu",
        element: <MenuManagementPage />,
      },
      {
        path: "gallery-categories",
        element: <GalleryCategoryPage />,
      },
      {
        path: "gallery",
        element: <GalleryManagementPage />,
      },
      {
        path: "business",
        element: <BusinessInfoPage />,
      },
      {
        path: "landing-images",
        element: <LandingImagesPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
